import { Modal, Form, Input } from "antd";
import { useState } from "react";

const RejectModal = ({ open, onCancel, onConfirm,setRejectReason }) => {
  const [form] = Form.useForm();

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      console.log(values, "val")
      // setRejectReason(values.note);
      onConfirm();
      form.resetFields();
    } catch (err) {
      // Nếu lỗi validation thì không làm gì
    }
  };
  // onConfirm(handleOk);
  return (
    <Modal
      title="Nhập lý do từ chối"
      open={open}
      onCancel={() => {
        form.resetFields();
        onCancel();
      }}
      onOk={handleOk}
      okText="Xác nhận từ chối"
      cancelText="Hủy"
      destroyOnClose
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="note"
          rules={[{ required: true, message: "Vui lòng nhập lý do từ chối!" }]}
        >
          <Input.TextArea placeholder="Nhập lý do từ chối..." rows={4} onChange={(e) => setRejectReason(e.target.value)}/>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default RejectModal;
